import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Box } from '@material-ui/core';
import { textInCapitalCase } from '../../../../../helpers/TextHelper';
import { useBenefitStyles } from './styles';

const Benefit = ({ ...props }) => {
  const { icon, title, description } = props;
  const classes = useBenefitStyles();
  return (
    <Grid item xs={12} className={classes.container}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box display="flex">
          <div className={classes.icon}>{icon}</div>
          <Typography className={classes.title}>
            {textInCapitalCase(title)}
          </Typography>
        </Box>
        <Typography className={classes.description}>{description}</Typography>
      </Box>
    </Grid>
  );
};

Benefit.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Benefit;
